export const HOSTNAMES: Record<string, string> = {
  production: "site.rocketalumnisolutions.com",
  preview: "preview.site.rocketalumnisolutions.com",
  dev: "dev.site.rocketalumnisolutions.com",
  local: "localhost",
};

const { hostname: currentHostname } = window.location;

export function getHostname(): string {
  return currentHostname;
}

export function isProductionHostname(): boolean {
  return currentHostname === HOSTNAMES.production;
}

export function isPreviewHostname(): boolean {
  return currentHostname === HOSTNAMES.preview;
}

export function isDevHostname(): boolean {
  return currentHostname === HOSTNAMES.dev;
}

export function isLocalHostname(): boolean {
  return currentHostname === HOSTNAMES.local;
}

export function isCustomDomain(): boolean {
  return (
    !isProductionHostname() &&
    !isPreviewHostname() &&
    !isDevHostname() &&
    !isLocalHostname()
  );
}

export function isUsingProductionData(): boolean {
  return isCustomDomain() || isProductionHostname() || isPreviewHostname();
}
